const formateadorCOP = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
})

export function formatearPrecio(valor) {
  if (typeof valor !== 'number' || Number.isNaN(valor)) return ''
  return formateadorCOP.format(valor)
}

/**
 * Precio de un gatico entregado como reproductor (sin esterilizar) en vez de
 * esterilizado: el mismo recargo porcentual que valida y aplica
 * generarLinkPedidoWhatsapp en functions/index.js — se duplica a propósito
 * porque el cliente y las Cloud Functions son runtimes separados que no
 * comparten código, pero el cálculo (y el redondeo al peso) debe dar
 * exactamente el mismo resultado en los dos lados para que lo que se muestra
 * en el sitio coincida con lo que termina en el mensaje de WhatsApp.
 */
export function calcularPrecioReproductor(precio, porcentaje) {
  if (typeof precio !== 'number' || Number.isNaN(precio)) return precio
  return Math.round(precio * (1 + porcentaje / 100))
}
